document.addEventListener('DOMContentLoaded', function () {
    const imagemodal = document.getElementById('imagemodal');
    const imagePreview = imagemodal?.querySelector('.imagepreview');
    const closeBtn = imagemodal?.querySelector('.close');
    const overlay = document.querySelector('.modal-overlay');
    const triggers = document.querySelectorAll('.magnified');
    const modalContent = imagemodal?.querySelector('.modal-content');
    const modalDialog = imagemodal?.querySelector('.modal-dialog');

    function showModal(src) {
        if (!imagemodal || !overlay) return;
        if (imagePreview && src) imagePreview.src = src;
        imagemodal.classList.add('show');
        imagemodal.style.display = 'block';
        imagemodal.style.top = '50%';
        imagemodal.style.transform = 'translateY(-50%)';
        imagemodal.style.maxHeight = 'calc(100% - 3.5rem)';
        overlay.style.display = 'block';
    }

    function hideModal() {
        if (!imagemodal || !overlay) return;
        imagemodal.classList.remove('show');
        imagemodal.style.display = 'none';
        overlay.style.display = 'none';
    }

    // Open on image/link click
    triggers.forEach(trigger => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            const img = this.querySelector('img');
            const src = img ? img.getAttribute('src') : null;
            showModal(src);
        });
    });

    // Close on explicit controls
    if (closeBtn) {
        closeBtn.addEventListener('click', hideModal);
    }
    if (overlay) {
        overlay.addEventListener('click', hideModal);
    }

    // Prevent clicks inside modal content from bubbling to the document
    if (modalContent) {
        modalContent.addEventListener('click', function (e) {
            e.stopPropagation();
        });
    }

    // Close when clicking anywhere outside the modal content
    document.addEventListener('click', function (e) {
        if (!imagemodal || !imagemodal.classList.contains('show')) return;

        // Ignore clicks on triggers
        if (e.target.closest('.magnified')) return;

        // If the click is inside the modal wrapper BUT NOT inside .modal-content -> close
        if (e.target.closest('#imagemodal') && !e.target.closest('.modal-content')) {
            hideModal();
            return;
        }

        // Also close if clicking the overlay
        if (e.target === overlay) {
            hideModal();
        }
    });

});
